/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./face.vue?vue&type=template&id=3bfcc271&scoped=true"
import script from "./face.vue?vue&type=script&lang=js"
export * from "./face.vue?vue&type=script&lang=js"
import style0 from "./face.vue?vue&type=style&index=0&id=3bfcc271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcc271",
  null
  
)

export default component.exports